const APIURL = 'https://api.rungreet.com/cookiestore/api'
export default APIURL;
// https://api.rungreet.com/cookiestore/api/getCookiesDetails
